export default {
  tickets: [],
  pagination: {},
  ticket: {}
}
